export default {"src":"/_next/static/media/arrow-right.5668cab2.svg","height":20,"width":12};